import { call, put, takeLatest } from "@redux-saga/core/effects";
// import { ConfigTableParser } from "./ConfigParser";
import { RequestVehicleApi } from "./RequestApi";
import { RequestConstant } from "./RequestConstant";
import { RequestParser } from "./RequestParser";

function* getRequestVehicleData(payload ) {
  try {
    yield put({ type: RequestConstant.REQUEST_VEHICLE_REQUEST });

    const res = yield call(RequestVehicleApi.getRequestVehicleData, payload );
    const result = RequestParser.getRequestVehicleParser(res);

    yield put({
      type: RequestConstant.REQUEST_VEHICLE_RESPONSE,
      payload: result,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: RequestConstant.REQUEST_VEHICLE_RESPONSE,
      payload: [],
    });
  }
}

export function* RequestDataSaga() {
  yield takeLatest(RequestConstant.REQUEST_VEHICLE_SAGA, getRequestVehicleData);
}
